var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullscreenFrontageDialog',{ref:"frontageDialog",scopedSlots:_vm._u([{key:"default",fn:function(dialogProps){return [_c('ClientPackageHistoryDialog',_vm._b({attrs:{"is-open":true},on:{"close":_vm.handleClose}},'ClientPackageHistoryDialog',dialogProps,false))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }